<div class="px-4 xl:px-0 flex w-full">
  <hr class="bg-[#DEE1E7] max-w-screen-xl w-full mx-auto h-[1px]">
</div>
<div
  class="px-4 xl:px-0 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-x-9 gap-y-20 max-w-screen-xl mx-auto w-full items-start py-[50px]">
  <div class="flex flex-col gap-4">
    <p class="section-title">{{'footer.grens' | translate}}</p>
    <div class="flex flex-col gap-1">
      <a class="link-section" [href]="getPublicPath(ROUTES.ABOUT_US)">{{'footer.about_us' | translate}}</a>
      <a class="link-section" href="#">{{'footer.look_for_a_job' | translate}}</a>
      <a class="link-section" href="#">{{'footer.find_professional' | translate}}</a>
    </div>
  </div>
  <div class="flex flex-col gap-4">
    <p class="section-title">{{'footer.useful_info' | translate}}</p>
    <div class="flex flex-col gap-1">
      <a class="link-section" href="#">{{'footer.help' | translate}}</a>
      <a class="link-section" href="#">{{'footer.security' | translate}}</a>
      <a class="link-section" [href]="getPublicPath(ROUTES.PRIVACY_POLICY)">{{'footer.privacy' | translate}}</a>
      <a class="link-section" href="#">{{'footer.service_use' | translate}}</a>
      <a class="link-section" [href]="getPublicPath(ROUTES.COOKIE_POLICY)">{{'footer.cookie_policy' | translate}}</a>
      <a class="link-section" href="#">{{'footer.cookie_handling' | translate}}</a>
    </div>
  </div>
  <div class="flex flex-col gap-4">
    <p class="section-title">{{'footer.private_area' | translate}}</p>
    <div class="flex flex-col gap-1">
      <a class="link-section" [href]="getPublicPath(ROUTES.CANDIDATE)">{{'footer.candidates_area' | translate}}</a>
      <a class="link-section" [href]="getPublicPath(ROUTES.EMPLOYER)">{{'footer.employers_area' | translate}}</a>
    </div>
  </div>
  <div class="flex flex-col gap-4">
    <p class="section-title">{{'footer.app' | translate}}</p>
    <div class="flex flex-col gap-1">
      <a href="" target="_blank">
        <img src="/assets/image/markets/google_play.png" class="w-[241px] h-[70px] bg-black-200 object-cover" alt="Google Play Store" />
      </a>
      <a href="" target="_blank">
        <img src="/assets/image/markets/app_store.png" class="w-[241px] h-[70px] bg-black-200 object-cover" alt="Apple App Store" />
      </a>
    </div>
  </div>
</div>

<div class="bg-brand-primary w-full py-4">
  <p class="text-center text-footer" [innerHTML]="'footer.text' | translate"></p>
</div>